module.exports = __webpack_public_path__ + "static/media/person.2890c324.svg";